module.exports = __webpack_public_path__ + "img/left-circles.4e9b3fc0.svg";